var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* eslint-disable max-len */
import { Auth } from "aws-amplify";
import * as React from "react";
import { connect } from "react-redux";
import { ThemePalette } from "../../../../../../theme/_Types";
import { Blockquote } from "../../../../05-atoms/Blockquote";
import { Button } from "../../../../05-atoms/Button";
import { Form } from "../../../../07-organisms/Form";
import * as Forms from "../../../../07-organisms/Form/index";
import * as I18n from "../../../../../../utils/translations/I18n";
/**
 *
 */
var ChangePasswordComp = /** @class */ (function (_super) {
    __extends(ChangePasswordComp, _super);
    /**
     *
     * @param props
     */
    function ChangePasswordComp(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.initState();
        _this.initState = _this.initState.bind(_this);
        _this.changePassword = _this.changePassword.bind(_this);
        return _this;
    }
    /**
     *
     */
    ChangePasswordComp.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            this.state.errorMsg ? (React.createElement(React.Fragment, null,
                React.createElement(Blockquote, null,
                    React.createElement("div", { className: "scl-h-text" }, this.state.errorMsg)),
                React.createElement("br", null)))
                : this.state.updated ? (React.createElement(React.Fragment, null,
                    React.createElement(Blockquote, null,
                        React.createElement("div", { className: "scl-h-text" }, I18n.getText("mary.09-views.03-modals.accountsettings.tabs.changepassword--success", "Your password has been changed successfully."))),
                    React.createElement("br", null)))
                    : React.createElement(React.Fragment, null),
            React.createElement(Form, null,
                React.createElement(Forms.FormField, { label: I18n.getText("mary.09-views.03-modals.accountsettings.tabs.changepassword-old-password-label", "Old password"), type: "password", onChange: function (value) {
                        return _this.setState({ oldPassword: (value === null || value === void 0 ? void 0 : value.toString()) || "" });
                    }, value: this.state.oldPassword }),
                React.createElement(Forms.FormField, { label: I18n.getText("mary.09-views.03-modals.accountsettings.tabs.changepassword-new-password-label", "New password"), type: "password", onChange: function (value) {
                        return _this.setState({ newPassword: (value === null || value === void 0 ? void 0 : value.toString()) || "" });
                    }, value: this.state.newPassword, max: 99, min: 6, validationFunction: function (value) {
                        var _a;
                        return Forms.meetsPasswordValidation(value, (_a = I18n.getText("mary.09-views.03-modals.accountsettings.tabs.changepassword-new-password--valid", "Password provided.")) !== null && _a !== void 0 ? _a : "", 99, 6);
                    } }),
                React.createElement(Button, { theme: { palette: ThemePalette.BRAND_ACCENT }, link: {
                        onClick: function () { return _this.changePassword(_this.state.oldPassword, _this.state.newPassword); },
                    }, disabled: !(this.state.oldPassword && this.state.newPassword) }, I18n.getText("mary.09-views.03-modals.accountsettings.tabs.changepassword-new-password-submit-btn", "Change")))));
    };
    ChangePasswordComp.prototype.initState = function () {
        return {
            updated: false,
            hasError: false,
            errorMsg: "",
            oldPassword: "",
            newPassword: "",
        };
    };
    ChangePasswordComp.prototype.changePassword = function (oldpass, newpass) {
        var _this = this;
        this.setState(this.initState());
        Auth.currentAuthenticatedUser()
            .then(function (user) { return Auth.changePassword(user, oldpass, newpass); })
            .then(function (_data) {
            _this.setState({
                updated: true,
            });
        })
            .catch(function (err) {
            var _a, _b;
            if (err) {
                _this.setState({
                    hasError: true,
                    errorMsg: (_b = (_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "",
                });
            }
        });
    };
    return ChangePasswordComp;
}(React.Component));
export { ChangePasswordComp };
/**
 *
 */
export var ChangePassword = connect(undefined, undefined)(ChangePasswordComp);
